import React from 'react';

import {
  Modal as ChakraModal,
  ModalOverlay,
  ModalProps,
} from '@chakra-ui/react';

interface MyModalProps extends ModalProps {
  isOpen: boolean
}

export default function Modal({
  children,
  isOpen,
  onClose,
  ...rest
}: MyModalProps) {
  return (
    <>
      <ChakraModal
        isOpen={isOpen}
        onClose={onClose}
        {...rest}>
        <ModalOverlay />
        {children}
      </ChakraModal>
    </>
  );
}
